<template>
  <header id="header">
    <Navbar/>
    <div class="header-top">
      <v-container>
        <div class="logo">
          <Widget position="logo"/>
        </div>
        <div class="auth-header">
          <div class="logo">
            <Widget position="logo"/>
          </div>
          <template v-if="isLoggedIn">
            <div class="user-slot">
              <div class="user-select">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <div>
                      <span class="user-icon"></span>
                      <span>{{ user.fio }}</span>
                    </div>
                    <v-btn v-on="on">
                      <span class="caret"></span>
                    </v-btn>
                  </template>
                  <v-list class="profile-dropdown-content">
                    <v-list-item>
                      <router-link to="/profile">{{ $t('Профиль') }}</router-link>
                    </v-list-item>
                    <v-list-item>
                      <a href="#" @click.prevent="logout">{{ $t('Выйти') }}</a>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </div>
<!--            <div class="notification">-->
<!--              <Badge/>-->
<!--            </div>-->
            <div class="lnk-home">
              <a href="/">
                <img src="@/assets/img/home-icon.png" alt="home">{{ $t('Главная') }}
              </a>
            </div>
          </template>
        </div>
        <div class="mob-menu">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn dark v-on="on" class="navbar-toggler">
                <img src="@/assets/img/icons/navbar-toggler-icon.png" alt="" />
              </v-btn>
            </template>
            <v-list class="navbar-collapse">
              <v-list-item>
                <div class="auth-profile">
                  <router-link to="/my-organization" v-if="isLoggedIn">{{ $t("Рабочий кабинет") }}</router-link>
                  <router-link to="/login" v-if="!isLoggedIn">{{ $t("Войти") }}</router-link>
                  <a href="#" @click.prevent="logout" v-if="isLoggedIn">{{ $t("Выйти") }}</a>
                </div>
              </v-list-item>
              <v-list-item>
                <Language />
              </v-list-item>
              <v-list-item>
                <Widget position="MainMenu" />
              </v-list-item>
              <v-list-item>
                <Widget position="NavbarMenu"/>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-container>
    </div>
  </header>
</template>

<script>
import Widget from '@/components/app/Widget'
import Navbar from '@/components/Navbar'
import Badge from '@/components/app/Badge'
import Language from '@/components/app/Language'

export default {
  name: 'Header',
  components: {
    Widget,
    Navbar,
    Badge,
    Language
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    },
    user () {
      let user = this.$store.getters.user
      if (Object.keys(user).includes('fio') === false) {
        user = this.$store.getters.checkUser
      }
      return user
    }
  },
  methods: {
    async logout () {
      await this.$store.dispatch('logout')
      this.$router.push('/login')
    }
  }
}
</script>
